import {
  WireCoverageOption,
  WireCoverageOptionType,
} from 'scenes/common/api/quote/types';
import { availableExtras } from 'scenes/landlord/helpers/OptionalExtras/availableExtras';
import { getIncludedExtras, getCoverType } from 'scenes/landlord/selectors';
import { LandlordFunnelState, OptionalExtra } from 'scenes/landlord/types';

export const toWireOptions = (
  state: LandlordFunnelState,
  extras?: string[]
): WireCoverageOption[] | undefined =>
  availableExtras[getCoverType(state)].map(({ code }) => ({
    name: code,
    value: [...(extras || []), ...getIncludedExtras(state)].includes(code),
  }));

export const toOptionalExtra = (
  option: WireCoverageOptionType
): OptionalExtra => {
  switch (option) {
    case WireCoverageOptionType.TenantDamage:
      return OptionalExtra.TenantDamage;
    case WireCoverageOptionType.FusionContent:
      return OptionalExtra.LossOfRent;
    case WireCoverageOptionType.FusionBuilding:
      return OptionalExtra.FusionBuilding;
    case WireCoverageOptionType.GeneralPortables:
      return OptionalExtra.FusionContent;
    default:
      return OptionalExtra.Unspecified;
  }
};
